module.exports = __webpack_public_path__ + "img/Ik voel mij veilig.c11335e0.png";